import axios from "axios";
import appConfig from "config/appConfig";
import { verifyTokenExpire } from "middleware/verifyToken";

export const fetchAccountTypes = async () => {
  if (!verifyTokenExpire()) return null;

  try {
    const response = await axios.get(`${appConfig.apiDomaine}/account-types`);
    return response.data;
  } catch (error) {
    console.error("Error fetching account types:", error);
    throw error;
  }
};

export const deleteAccountType = async (typeId) => {
  if (!verifyTokenExpire()) return null;

  try {
    const response = await axios.delete(
      `${appConfig.apiDomaine}/account-types/${typeId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting account type:", error);
    throw error;
  }
};

const typeCompteService = {
  fetchAccountTypes,
  deleteAccountType,
};

export default typeCompteService;
